// import React from 'react';

// const ViewInsightsUIDetails = () => {
//   return (
//     <iframe 
//       src="https://insights-ui.symbl.ai/meeting-details/4730879065456640?o=9f13351b6235256b5d09a3707109a507fad9b7c23c3331749a3f6e63e6ad2e31849639ab76ed3002b47f48214a3dda28e2a40dbf24f05723f31437b79bfe055c61d6af8b6ff1b15ff52bd6b19c208a0333b937f7299d2ca8c78fdc5b8bd4243dc0b02d1505dfcb19ce2835ac817ce61d0328241fa300c73519805a2bd5134b8cb6ea3532115b6b727a99d3d1da93dc90ac59d08393b09ef5576df2d9f5cceda15004e5eba0a0e65b377101079f37e76437bb9433b8a67f7975cacaa5d27d6aea0053d36329af653a214e1e6138a20ba120c50405c32ed79494854b76a646955d70f31b344534cae09880f74d2775171c50cdfe26b2f7a7ff8e234509ea290af4f11262aa8cbdba65257d9ac4b75a44e54857e50d&includeCallScore=true" 
//       style={{border: 0, width: "100%", height: "1000px"}}>
//     </iframe>
//   )
// }
// export default ViewInsightsUIDetails;

import React, { useState, useEffect, useRef } from 'react';
import {createSearchParams, useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {fetchTranscriptMessages, fetchAttendees} from "../../services/callScore";

import CallScoreFactors from '../CallScore/HumanCallScoreReport/CallWrapUI/CallScoreFactors'
import CallScore from '../CallScore/HumanCallScoreReport/CallWrapUI/CallScore'
import Transcription from '../Transcription/Transcription'
import { formatTranscriptMessages } from "../../utils"
import { SAMPLE_CALL_SCORE, SAMPLE_CONVERSATION_ID } from '../../constants';


import {
    ACCESS_TOKEN_QUERY_PARAM_NAME, ERROR_DATA_NOT_FOUND,
    INCLUDE_CALL_SCORE_QUERY_PARAM,
    INCLUDE_CALL_SCORE_TYPES,
    MeetingNotFoundForConversationIdErrorMessage,
    MeetingsLoadingErrorMessage, recordingUrlCannotBeLoadedForAudioPlayer, recordingUrlNotPresentForAudioPlayer,
    transcriptionErrorMessage,
    UnauthenticatedUserErrorMessage,
    USER_EVENTS,
    VIEW_DEMO_QUERY_PARAM_NAME,
    SHOW_BACK_BUTTON,
    SHOW_SYMBL_BANNER, CONVERSATION_TYPES,
} from "./constants";
import MeetingHeader from "./MeetingHeader/MeetingHeader";
import MeetingOverviewLoader from "./Loaders/MeetingOverviewLoader";
import "./ViewInsightsUI.scss";
import MeetingSummary from "./MeetingSummary/MeetingSummary";
import {ReactComponent as SummaryTabIcon} from "../../assets/icons/SummaryTab.svg";
import {ReactComponent as CallSentimentTabIcon} from "../../assets/icons/CallSentimentTab.svg";
import {ReactComponent as CallScoreTabIcon} from "../../assets/icons/CallScoreTab.svg";
import {ReactComponent as NextStepsTabIcon} from "../../assets/icons/NextStepsTab.svg";
import {ReactComponent as QuestionAndAnswersTabIcon} from "../../assets/icons/QuestionAndAnswersTab.svg";
import {ReactComponent as ObjectionsTabIcon} from "../../assets/icons/ObjectionsTab.svg";
import SentimentChart from "./SentimentChart/SentimentChart";
import Sentiment from "./Sentiment/Sentiment";
import QuestionAndAnswer, {TYPES} from "./QuestionAndAnswer/QuestionAndAnswer";
import NextSteps from "./NextSteps/NextSteps";
import {calculateTime, compareStringWithoutCase} from "./helpers/utility";
import {ReactComponent as ArrowLeft} from "../../assets/icons/ArrowLeft.svg";
import {ReactComponent as CloseIcon} from "../../assets/icons/Close.svg";
import SymblLogo from "../../assets/Logo.png";
import {useElementOnScreen} from "./customHooks/useElementOnScreen";
import {demoMeetings} from "./demoData/demoMeetings";
import Metrics from './services/Metrics'
import AudioPlayer from "./AudioPlayer/AudioPlayer";
import {transcription} from "./demoData/messages";
import {Button, Snackbar} from "@mui/material";
// import {transcription} from "../../demoData/transcription";
// import {messages} from "../../demoData/transcription";

const ViewInsightsUI = () => {
    const {conversationId} = useParams();

    const [meetingDetails, setMeetingDetails] = useState(null);
    console.log('this is meetingDetails', meetingDetails)
    const [attendeesIdsWithIndex, setAttendeesIdsWithIndex] = useState(null);
    const [meetingFetchError, setMeetingFetchError] = useState(null);
    const [meetingDetailsLoading, setMeetingDetailsLoading] = useState(false);
    console.log('this is meetingDetailsLoading', meetingDetailsLoading)

    const [messages, setMessages] = useState(null);
    const [messagesError, setMessagesError] = useState(null);
    console.log('this is messagesError', messagesError)
    const [messagesLoading, setMessagesLoading] = useState(false);

    const [displayConfig, setDisplayConfig] = useState(null);
    const [displayConfigError, setDisplayConfigError] = useState(null);
    const [displayConfigLoading, setDisplayConfigLoading] = useState(false);
    console.log('this is displayConfigLoading', displayConfigLoading)
    const [audioError, setAudioError] = useState(false);

    const [searchParams] = useSearchParams();
    const accessToken = searchParams.get(ACCESS_TOKEN_QUERY_PARAM_NAME);

    const includeCallScore = compareStringWithoutCase(searchParams.get(INCLUDE_CALL_SCORE_QUERY_PARAM), INCLUDE_CALL_SCORE_TYPES.TRUE);
    // const viewDemo = searchParams.get(VIEW_DEMO_QUERY_PARAM_NAME);
    const viewDemo = "true";

    const [summaryRef, isSummaryVisible] = useElementOnScreen({root: null, rootMargin: "0px", threshold: 1.0});
    const [callSentimentRef, isCallSentimentVisible] = useElementOnScreen({root: null, rootMargin: "0px", threshold: 1.0});
    const [callScoreRef, isCallScoreVisible] = useElementOnScreen({root: null, rootMargin: "0px", threshold: 0.5});
    const [nextStepsRef, isNextStepsVisible] = useElementOnScreen({root: null, rootMargin: "0px", threshold: 1.0});
    const [objectionsRef, isObjectionsVisible] = useElementOnScreen({root: null, rootMargin: "0px", threshold: 0.3});
    const [questionsAndAnswersRef, isQuestionsAndAnswersVisible] = useElementOnScreen({root: null, rootMargin: "0px", threshold: 0.3});

    const dataFetchedRef = useRef(false);
    const audioRef = useRef(null);

    const MEETING_DETAILS_MENU = {
        INSIGHTS: 'insights_menu',
        TRANSCRIPT: 'transcript_menu'
    }
    const MENU_ITEMS = [
        {
            key: MEETING_DETAILS_MENU.INSIGHTS,
            name: 'Insights'
        },
        {
            key: MEETING_DETAILS_MENU.TRANSCRIPT,
            name: 'Transcription'
        }
    ]


    const [selectedMenu, setSelectedMenu] = useState(MEETING_DETAILS_MENU.INSIGHTS);

    const TAB_KEYS = {
        SUMMARY: 'summary_tab',
        CALL_SENTIMENT: 'call_sentiment_tab',
        CALL_SCORE: 'call_score_tab',
        NEXT_STEPS: 'next_steps_tab',
        QUESTION_AND_ANSWERS: 'question_and_answers_tab',
        OBJECTIONS: 'objections_tab'
    }
    const tabs = [
        {
            key: TAB_KEYS.SUMMARY,
            name: 'Summary',
            ref: summaryRef,
            Icon: SummaryTabIcon,
            className: "summary-tab"
        },
        {
            key: TAB_KEYS.CALL_SENTIMENT,
            name: 'Call Sentiment',
            ref: callSentimentRef,
            Icon: CallSentimentTabIcon,
            className: "call-sentiment-tab"
        },
        {
            key: TAB_KEYS.CALL_SCORE,
            name: 'Call Score',
            ref: callScoreRef,
            Icon: CallScoreTabIcon,
            className: "call-score-tab"
        },
        {
            key: TAB_KEYS.NEXT_STEPS,
            name: 'Next Steps',
            ref: nextStepsRef,
            Icon: NextStepsTabIcon,
            className: "next-steps-tab"
        },
        {
            key: TAB_KEYS.OBJECTIONS,
            name: 'Objections',
            ref: objectionsRef,
            Icon: ObjectionsTabIcon,
            className: "objections-tab"
        },
        {
            key: TAB_KEYS.QUESTION_AND_ANSWERS,
            name: 'Questions And Answers',
            ref: questionsAndAnswersRef,
            Icon: QuestionAndAnswersTabIcon,
            className: "question-and-answers-tab"
        }]
    const [activeTab, setActiveTab] = useState(tabs[0].key);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if(isQuestionsAndAnswersVisible) {
            setActiveTab(TAB_KEYS.QUESTION_AND_ANSWERS)
        } else if(isObjectionsVisible) {
            setActiveTab(TAB_KEYS.OBJECTIONS)
        } else if(isNextStepsVisible) {
            setActiveTab(TAB_KEYS.NEXT_STEPS)
        } else if(isCallScoreVisible) {
            setActiveTab(TAB_KEYS.CALL_SCORE)
        } else if(isCallSentimentVisible) {
            setActiveTab(TAB_KEYS.CALL_SENTIMENT)
        } else if(isSummaryVisible) {
            setActiveTab(TAB_KEYS.SUMMARY);
        }
    }, [isSummaryVisible, isCallSentimentVisible, isCallScoreVisible, isNextStepsVisible, isObjectionsVisible, isQuestionsAndAnswersVisible])

    const getChangedMeetingObjectKeys = (meetingDetails) => {
        return meetingDetails?.callObjections?.objections?.map(({
                                                             objection,
                                                             objectionBy,
                                                             objectionTime,
                                                             response,
                                                             responseBy,
                                                             responseTime
                                                         }) => ({
            question: objection,
            questionBy: objectionBy,
            questionTime: objectionTime,
            answer: response,
            answerBy: responseBy,
            answerTime: responseTime
        }));
    };
    const getMessagesToDisplay = (messages) => {
        return messages.map(({from, text, timeOffset, startTime, endTime, id}) => {
            return {
                name: from?.name,
                text: text,
                timeOffsetToShow: calculateTime(timeOffset),
                timeOffset: timeOffset,
                startTime,
                endTime,
                id,
                from
            }
        });
    }


    useEffect(() => {
        (async () => {
            if(viewDemo === "true") {
                setMeetingDetailsLoading(true);
                console.log('hi hi')
                setTimeout(() => {
                    // const meeting = demoMeetings.find(meeting => meeting.conversationId === conversationId);
                    const meeting = demoMeetings[1];
                    console.log('this is meeting', meeting)
                    if(meeting) {
                        const changedMeetingObjectionKeys = getChangedMeetingObjectKeys(meeting);
                        setMeetingDetails({...meeting, callObjections: {objections: changedMeetingObjectionKeys}});
                        setMessages(getMessagesToDisplay(transcription.messages));
                        console.log('hey hey!')
                    }else {
                        setMeetingFetchError(MeetingNotFoundForConversationIdErrorMessage)
                    }
                    setMeetingDetailsLoading(false);
                }, 1000);

                console.log('what...?')
                return;
            }
            if (!accessToken) {
                setMeetingFetchError(UnauthenticatedUserErrorMessage)
                setMeetingDetailsLoading(false);
                return;
            }
            if (dataFetchedRef.current) return;
            dataFetchedRef.current = true;
            setMeetingDetailsLoading(true);

            // try {
            //     setDisplayConfigLoading(true);
            //     const data = await getDisplayConfig(accessToken);
            //     if(!!data) {
            //         setDisplayConfig(data);
            //     } else {
            //         setDisplayConfigError(true);
            //     }
            //     setDisplayConfigLoading(false);
            // } catch (exception) {
            //     setDisplayConfigError(true);
            //     setDisplayConfigLoading(false);
            // }

            try {
                const meetingDetails = await getMeetingDetails(accessToken, conversationId);
                setMeetingDetailsLoading(false);

                const changedMeetingObjectionKeys = getChangedMeetingObjectKeys(meetingDetails);
                setMeetingDetails({...meetingDetails, callObjections: {objections: changedMeetingObjectionKeys}});
                const attendeesIdsWithIndex = meetingDetails?.attendees?.reduce((attendeeIdsWithIndex,{id},index) => ({...attendeeIdsWithIndex, [id]: index}) , {});
                setAttendeesIdsWithIndex(attendeesIdsWithIndex);

                Metrics.track(USER_EVENTS.VIEWED_MEETING_DETAILS_PAGE);
            } catch (exception) {
                if (exception) {
                    setMeetingFetchError(exception)
                } else {
                    setMeetingFetchError(MeetingsLoadingErrorMessage)
                }
                setMeetingDetailsLoading(false);
            }

            try {
                setMessagesLoading(true);
                const data = await getMessages(accessToken, conversationId);
                if(!!data.messages && data.messages.length > 0) {
                    setMessages(getMessagesToDisplay(data.messages));
                } else {
                    setMessagesError(true);
                }
                setMessagesLoading(false);
            } catch (exception) {
                setMessagesError(true);
                setMessagesLoading(false);
            }
        })();
    }, []);

    const scrollIntoView = (key, reference) => {
        setActiveTab(key);
        reference.current.scrollIntoView({behavior: 'smooth'})
    }

    const goToMeetingList = () => {
        const state = !!location?.state?.selectedStartDate && !!location?.state?.selectedEndDate ? location.state : null;
        navigate({
            pathname: `/`,
            search: `?${createSearchParams(searchParams)}`,
        }, {state});
    }

    const [currentAudioTime, setCurrentAudioTime] = useState(null);
    const [audioLoaded, setAudioLoaded] = useState(false);
    const [showAudioNotLoadedSnackbar, setShowAudioNotLoadedSnackbar] = useState(true);
    const hideAudioNotLoadedSnackbar = () => {
        setShowAudioNotLoadedSnackbar(false);
    }

    const setDuration = () => {
        // let totalSeconds = audioRef.current.audio.current.duration;
        setAudioLoaded(true);
    }

    const onSeeked = (e) => {
        let timeInSeconds = e.target.currentTime;
        setCurrentAudioTime(timeInSeconds);
    }

    const onListen = (e) => {
        let timeInSeconds = e.target.currentTime;
        setCurrentAudioTime(timeInSeconds);
    }

    const handleMenuClick = (menu) => {
        setSelectedMenu(menu);
    }

    const getAudioPlayerUrl = () => {
        // return 'https://storage.googleapis.com/call-score-staging-media/call-center.wav';
        const {audioUrl, videoUrl} = meetingDetails;
        return !!audioUrl ? audioUrl : !!videoUrl ? videoUrl : false;
    }

    const hideObjections = !meetingDetails?.callObjections?.objections || meetingDetails?.conversationType === CONVERSATION_TYPES.GENERAL;

    return <div className={"page-layout meeting-details-page-layout"} style={SHOW_SYMBL_BANNER && displayConfig?.showSymblBanner ? {} : {paddingTop: "16px", backgroundImage: "none", backgroundSize: "unset"}}>
        {SHOW_SYMBL_BANNER && displayConfig?.showSymblBanner && <img src={SymblLogo} className={"symbl-logo"}/> }
        {
            meetingDetailsLoading || messagesLoading || displayConfigLoading ? <MeetingOverviewLoader/>
            : !meetingFetchError && !!meetingDetails ?
            <div className={"max-page-content-width"}>
                <div className={"transparent-container meeting-header"}>
                    {
                        SHOW_BACK_BUTTON && displayConfig?.showBackButton === true && <div className={"go-back"} onClick={goToMeetingList}>
                            <ArrowLeft/>
                        </div>
                    }
                    <MeetingHeader conversationId={meetingDetails.conversationId}
                                   title={meetingDetails.meetingName}
                                   dateTime={meetingDetails.startTime}
                                   duration={meetingDetails.duration}
                                   prospectCompany={meetingDetails.prospectCompany}
                                   callStage={meetingDetails.callStage}
                                   attendees={meetingDetails.attendees}
                                   showAttendeeNames={true}
                                   displayConfig={displayConfig}/>
                </div>
                <div className={"menu-items"}>
                    {
                        MENU_ITEMS.map(({key, name}) => <div key={key} className={`${selectedMenu === key ? "active-menu-tab" : ""}`} onClick={() => handleMenuClick(key)}>
                            <p>{name}</p>
                            <div className={"highlight"}></div>
                        </div>)
                    }
                </div>
                {
                    selectedMenu === MEETING_DETAILS_MENU.INSIGHTS ? <div className={"meeting-details-container"}>
                        <div className={"tabs-container"}>
                            {
                                tabs.map(({key, name, ref, Icon, className}) => {
                                    return (!includeCallScore && key === TAB_KEYS.CALL_SCORE) ? <></>
                                        : (!meetingDetails.callSummary && key === TAB_KEYS.SUMMARY) ? <></>
                                            : (!meetingDetails.callSentiment && key === TAB_KEYS.CALL_SENTIMENT) ? <></>
                                                : (!meetingDetails.callNextSteps && key === TAB_KEYS.NEXT_STEPS) ? <></>
                                                    : (hideObjections && key === TAB_KEYS.OBJECTIONS) ? <></>
                                                        : (!meetingDetails.callQuestionAndAnswers && key === TAB_KEYS.QUESTION_AND_ANSWERS) ? <></>
                                                            : <button key={key} className={`tabs ${className} ${activeTab === key ? "activeTab" : ""}`} onClick={() => scrollIntoView(key, ref)}>
                                                                <Icon/> <p>{name}</p></button>
                                })
                            }
                        </div>
                        <div className={"tabs-description"}>
                            {
                                !!meetingDetails.callSummary && <div ref={summaryRef} className={"details-container"}>
                                    <MeetingSummary smallSummary={meetingDetails.callSummary.smallSummary}
                                                    mediumSummary={meetingDetails.callSummary.mediumSummary}
                                                    longSummary={meetingDetails.callSummary.longSummary}
                                                    hasError={!!meetingDetails?.callSummary?.error}
                                    />
                                </div>
                            }
                            {
                                !!meetingDetails.callSentiment && <div ref={callSentimentRef} className={"details-container"}>
                                    <div className={"call-sentiment-title"}><p className={"section-title"}>Call
                                        Sentiment</p>
                                        <Sentiment sentiment={meetingDetails.callSentiment.overallSentiment}
                                                   isBoldText={true}/>
                                    </div>
                                    <p>{meetingDetails.callSentiment.summary}</p>
                                    { !!meetingDetails.callSentiment.chunks && <SentimentChart messages={meetingDetails.callSentiment.chunks}/> }
                                </div>
                            }
                            {
                                includeCallScore && <div ref={callScoreRef} className={"details-container"}>
                                    <p className={"section-title"}>Call Score</p>
                                    {
                                        !!meetingDetails.callScore?.error ? <p className={"no-data-found"}>{ERROR_DATA_NOT_FOUND.CALL_SCORE}</p>
                                            : <>
                                                <p>{meetingDetails.callScore?.summary}</p>
                                                <CallScore callScore={meetingDetails.callScore?.score}
                                                           factors={meetingDetails.callScore?.criteria}
                                                           showColoredBackground={true}
                                                />
                                                <div className={"margin-20"}/>
                                                <CallScoreFactors factors={meetingDetails.callScore?.criteria}/>
                                            </>
                                    }
                                </div>
                            }
                            {
                                !!meetingDetails.callNextSteps && <div ref={nextStepsRef} className={"white-background-container details-container"}>
                                    <p className={"section-title"}>Next Steps</p>
                                    {
                                        !!meetingDetails?.callNextSteps?.error ||  meetingDetails?.callNextSteps?.nextSteps?.length === 0 ? <p className={"no-data-found"}>{ERROR_DATA_NOT_FOUND.NEXT_STEPS}</p>
                                            : <NextSteps nextSteps={meetingDetails.callNextSteps.nextSteps}/>
                                    }
                                </div>


                            }
                            {
                                hideObjections ? <></>
                                :  <div ref={objectionsRef}
                                                        className={"white-background-container details-container custom-question-answer-container"}>
                                    <p className={"section-title"}>Objections</p>
                                    {
                                        !meetingDetails?.callObjections?.objections ? <p className={"no-data-found"}>{ERROR_DATA_NOT_FOUND.CALL_OBJECTIONS}</p>
                                            : meetingDetails?.callObjections?.objections?.length ?
                                                <QuestionAndAnswer questionAndAnswers={meetingDetails.callObjections.objections}
                                                                   type={TYPES.OBJECTIONS}/>
                                                : <p className={"no-data-found"}> No objections found </p>
                                    }

                                </div>
                            }
                            {
                                !!meetingDetails.callQuestionAndAnswers && <div ref={questionsAndAnswersRef}
                                                                                className={"details-container white-background-container custom-question-answer-container"}>
                                    <p className={"section-title"}>Questions And Answers</p>
                                    {
                                        !meetingDetails?.callQuestionAndAnswers?.questionAnswers ? <p className={"no-data-found"}>{ERROR_DATA_NOT_FOUND.CALL_QUESTIONS_AND_ANSWERS}</p>
                                            : meetingDetails?.callQuestionAndAnswers?.questionAnswers?.length ? <QuestionAndAnswer
                                                    questionAndAnswers={meetingDetails.callQuestionAndAnswers.questionAnswers}
                                                    type={TYPES.QUESTION_ANSWER}/>
                                                : <p className={"no-data-found"}> No Questions and answers found </p>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    : <div className={"transcription-container"}>
                            {
                                messagesError ? <div className={"transcription-error"}>{transcriptionErrorMessage}</div>
                                    : <Transcription messages={messages} currentAudioTime={currentAudioTime} attendeesIdsWithIndex={attendeesIdsWithIndex} showAutoScroll={!!getAudioPlayerUrl() && audioLoaded && !audioError} />
                            }
                    </div>
                }
                <p className={"powered-by-symbl-ai-footer"} style={getAudioPlayerUrl() && !audioError ? {marginBottom: '48px'} :{marginBottom: 0}}>Powered by Symbl.ai</p>
                {
                    (getAudioPlayerUrl() && !audioError) && <AudioPlayer
                        src={getAudioPlayerUrl()}
                        audioRef={audioRef}
                        onError={() => setAudioError(true)}
                        onPlay={() => {}}
                        onPause={() => {}}
                        onSeeked={onSeeked}
                        onLoadedData={setDuration}
                        onListen={onListen}
                    />
                }
            </div>
            // : <div className={"error-message-container"}>
            //     <p className={"error-message"}>{meetingFetchError}</p>
            // </div>
            : null
        }
    </div>
}

export default ViewInsightsUI;